import React from 'react';
import '../../css/ContactPage.css';
import { MdPhone } from "react-icons/md";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFax } from 'react-icons/fa';
import { Navbar } from './Navbar';
import bannerImg from '../../images/contact.jpg';
import { Helmet } from "react-helmet-async";

const ContactPage = () => {
  return (
    <div>
      <Helmet>
        <title>Contact Real Estate Agent | 24Krealtors</title>
        <meta
          name="description"
          content="Find your perfect Chennai property! Contact 24Krealtors - Expert real estate agents. Inquire Now!."
        />
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "Contact 24K Realtors",
  "url": "https://www.24krealtos.com/contact",
  "description": "Find your perfect Chennai property! Contact 24Krealtors - Expert real estate agents. Inquire Now!.",
  "mainEntity": {
    "@type": "Organization",
    "name": "24k Realtors",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-9884855955",
      "contactType": "Customer Support",
      "areaServed": "IN",
      "availableLanguage": ["English", "Tamil"]
    }
  }
}
`}
        </script>
      </Helmet>

      <Navbar />
      {/* Banner */}
      <div className="banner">
        <div className="banner-text">
          <h1>Conatct Us</h1>
        </div>
      </div>

      <div className="contact-main">
        <div className="contact-left">
          <p className="heading-small">Interested in a project? Let’s talk</p>
          {/* <h2 className="primary-phone">
        <MdPhone /> +91 80562 10606
        </h2> */}


          <div className="info-block">
            <label className='para'>Headquarters</label>
            <p>
              No.2,1st Floor, KVIC NAGAR,<br />
              Velachery Rd, next to KTM Showroom,<br />
              Gowriwakkam, Chennai - 600073
              <a href="https://www.google.com/maps/dir//Landmark,+No.2,1st+Floor,+KVIC+NAGAR,+Velachery+Rd,+next+to+KTM+Showroom,+Gowriwakkam,+Chennai,+Tamil+Nadu+600073/@12.925438,80.0945451,12.34z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3a525ffe5455154b:0xae84c8671876e58e!2m2!1d80.1624582!2d12.9222893?entry=ttu&g_ep=EgoyMDI1MDMxOS4yIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer">
                Locate in Maps
              </a>
            </p>
          </div>

          <div className="info-block">
            <label className='para'>Phone</label>
            <p>+91 9884855955 </p>
          </div>
          {/* 
        <div className="info-block">
          <label>Fax</label>
          <p><FaFax /> +91 44 2434 6333</p>
        </div> */}

          <div className="info-block">
            <label className='para'>Email</label>
            <p><a href="mailto:pincodepillars@gmail.com" className="red">admin@24krealtors.com</a></p>
          </div>

          <div className="info-block">
            <label className='para'>Corporate Office</label>
            <p><span className='para'>Monday to Saturday</span><br /><strong>09.30 am to 06.30 pm</strong></p>
          </div>

          <div className="info-block">
            <label className='para'>Site Office</label>
            <p> <span className='para'>All Days</span><br /><strong>10.00 am to 07.00 pm</strong></p>
          </div>
        </div>

        <div className="contact-right">
          <h4>What we can help you with ?</h4>
          <form>
            <select>
              <option value="">Select Enquiry Type</option>
              <option>Buy Property</option>
              <option>Lease</option>
              <option>Collaboration</option>
            </select>

            <input type="text" placeholder="Name" />
            <input type="tel" placeholder="Mobile" />
            <input type="email" placeholder="Email ID" />

            <label className="checkbox">
              <input type="checkbox" defaultChecked />
              <span>
                I authorise 24krealtors to contact me via Email/SMS/Call. This overrides DND.
              </span>
            </label>

            <button type="submit" className="submit-btn">Send Enquiry</button>
          </form>
          <div className="contact-map">
            <iframe
              title="24K Realtors Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.5972951634857!2d80.16026937474846!3d12.92228928739056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525ffe5455154b%3A0xae84c8671876e58e!2sLandmark%2C%20No.2%2C1st%20Floor%2C%20KVIC%20NAGAR%2C%20Velachery%20Rd%2C%20next%20to%20KTM%20Showroom%2C%20Gowriwakkam%2C%20Chennai%2C%20Tamil%20Nadu%20600073!5e0!3m2!1sen!2sin!4v1711368937427!5m2!1sen!2sin"
              width="100%"
              height="350"
              style={{ border: 0, borderRadius: '10px', marginTop: '40px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
